import { css } from "@emotion/react";
import { BAR_HEIGHT } from "./constants";

export const styles = {
  chart: css`
    --bar-height: ${BAR_HEIGHT}px;
    position: relative;
    margin-bottom: calc(var(--bar-height) * 3);
  `,
  dateLines: css`
    display: flex;
    position: absolute;
    inset: 0;
    margin-bottom: calc(var(--bar-height) * -2);
  `,
  dateIndicator: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    &:last-of-type {
      flex: 0 0 1px;
    }

    &:after,
    &:before {
      position: absolute;
      width: max-content;
    }

    &:before {
      content: "";
      border-left: 1px solid var(--color-border-secondary);
      height: var(--bar-height);
      bottom: var(--bar-height);
    }

    &:hover {
      &:after {
        content: attr(data-date);
        bottom: calc(var(--bar-height) * -1);
      }

      &:before {
        border-color: var(--color-black);
        height: 100%;
        bottom: initial;
      }
    }

    &.full {
      border-left: 1px solid var(--color-border-secondary);
      color: var(--text-color-light);
      position: relative;

      &:hover {
        border-color: var(--color-black);

        &:after {
          bottom: initial;
        }
      }

      &:after {
        content: attr(data-date);
        background-color: var(--color-background-primary);
      }

      &:before {
        content: none;
      }
    }
  `,
  rangeBars: css`
    --range-bars-gap: 3px;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    gap: var(--range-bars-gap);

    @keyframes expandIn {
      from {
        border-color: var(--color-black);
        transform: scaleX(0);
      }
      to {
        border-color: rgb(var(--bar-rgb));
        transform: scaleX(1);
      }
    }
  `,
  rangeBar: css`
    --range-bar-border-width: 2px;
    position: relative;
    height: var(--bar-height);
    pointer-events: all;
    background-color: rgba(var(--bar-rgb), 0.7);
    border: var(--range-bar-border-width) solid rgb(var(--bar-rgb));
    animation: expandIn 200ms ease-in forwards;
    transform-origin: left center;
    transform: scaleX(0);

    &:hover {
      background-color: rgba(var(--bar-rgb), 0.4);
    }

    & > a > span {
      display: block;
      height: 100%;
    }

    &:before {
      content: "";
      position: absolute;
      height: var(--range-bars-gap);
      bottom: calc(100% + var(--range-bar-border-width));
      left: 0;
      right: 0;
    }
  `,
  noAnimation: css`
    .subKit-DateRangeBar {
      animation: none;
      transform: initial;
      border-color: rgb(var(--bar-rgb));
    }
  `
};
